import React from 'react';
import { Modal, Row, Col } from 'antd';
import * as S from './styles';

interface Props {
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
    type: 'presave' | 'save' | 'alert';
    open: boolean;
}

export const PlanogramConfirm: React.FC<Props> = ({
    onCancel,
    onConfirm,
    loading,
    type,
    open,
}) => {
    const ModalInfo = React.useMemo(() => {
        if (type === 'presave') {
            return {
                title: 'Atenção',
                text: 'Essa opção exclui os produtos selecionados dos planogramas. Após clicar em CONTINUAR e depois em SALVAR, essa ação não poderá ser desfeita',
            };
        }
        if (type === 'save') {
            return {
                title: 'Atenção',
                text: 'Essa ação irá atualizar o planograma e não poderá ser desfeita',
            };
        }
        if (type === 'alert') {
            return {
                title: 'Erro',
                text: 'Existem valores zerados ou inválidos.',
            };
        }
        return {
            title: '',
            text: '',
        };
    }, [type]);

    const onConfirmModal = () => {
        onConfirm();
    };

    return (
        <>
            <Modal
                centered
                title={<div style={{ fontSize: 20 }}>{ModalInfo.title}</div>}
                style={{ textAlign: 'center' }}
                styles={{
                    body: { textAlign: 'center' },
                }}
                open={open}
                closable={false}
                onOk={onConfirmModal}
                onCancel={onCancel}
                footer={[
                    type === 'presave' && (
                        <Row justify="center" gutter={[16, 16]}>
                            <Col>
                                <S.ButtonCancell
                                    danger
                                    onClick={onCancel}
                                    style={{ width: 200 }}
                                />
                            </Col>
                            <Col>
                                <S.ButtonConfirm
                                    onClick={onConfirmModal}
                                    loading={loading}
                                    className="default-btn"
                                    style={{ width: 200 }}
                                >
                                    Ok
                                </S.ButtonConfirm>
                            </Col>
                        </Row>
                    ),
                    type === 'save' && (
                        <Row justify="center" gutter={[16, 16]}>
                            <Col>
                                <S.ButtonCancell
                                    danger
                                    onClick={onCancel}
                                    style={{ width: 200 }}
                                />
                            </Col>
                            <Col>
                                <S.ButtonConfirm
                                    onClick={onConfirmModal}
                                    loading={loading}
                                    className="default-btn"
                                    style={{ width: 200 }}
                                >
                                    Salvar
                                </S.ButtonConfirm>
                            </Col>
                        </Row>
                    ),
                    type === 'alert' && (
                        <Row justify="center" gutter={[16, 16]}>
                            <Col>
                                <S.ButtonConfirm
                                    onClick={onCancel}
                                    style={{ width: 200 }}
                                    className="default-btn"
                                >
                                    Voltar
                                </S.ButtonConfirm>
                            </Col>
                        </Row>
                    ),
                ]}
            >
                {ModalInfo.text}
            </Modal>
        </>
    );
};
